import { jsx as _jsx } from "react/jsx-runtime";
import { HorizontalBarChart, TileFooter, TileCard, } from '@cmd/ui-components';
import { useGetData } from '@cmd/ui-utilities';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { dateRangeSelector } from '../../../components/LandingPageHeader/LandingPageHeader';
import { organizationSelector } from '../../../state/orgIdState';
import leadsApi, { LeadsDataSource, LeadsResource } from '../../../utils/apis/leadsApiUtils';
import { getNvisionAnalyzeLeadsUrl } from '../../../utils/urlUtils';
import topProductsDataFormatter from './productsThatDroveLeadsUtils';
const tileConfigs = {
    [LeadsDataSource.ATKBB]: {
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
    },
};
const ProductsThatDroveLeads = ({ 'data-testid': dataTestId, limit = 10, // ToDo correct limit?
source, }) => {
    const intl = useIntl();
    const testId = `${dataTestId || 'ids'}-products-that-drove-leads`;
    const { sourceMessage } = tileConfigs[source] || { sourceMessage: () => '' };
    const dateRange = useSelector(dateRangeSelector);
    const orgId = useSelector(organizationSelector);
    const params = {
        ...(orgId !== undefined ? { orgId } : {}),
        ...dateRange,
        limit,
    };
    // Unsure of real endpoint - may change
    const endpoint = `${source}/${LeadsResource.TOP_PRODUCTS}`;
    const { data, isLoading, error, } = useGetData(() => leadsApi[endpoint].get(params, {
        headers: {
            accept: 'application/vnd.coxauto.v2+json',
        },
    }), params, topProductsDataFormatter);
    const { chartData, lastUpdatedUTC } = data || {};
    return (_jsx(TileCard, { title: intl.formatMessage({
            id: 'PRODUCTS_THAT_DROVE_LEADS_TILE_TITLE',
            defaultMessage: 'Products that Drove Leads',
        }), description: intl.formatMessage({
            id: 'PRODUCTS_THAT_DROVE_LEADS_TILE_DESC',
            defaultMessage: 'Lead count based on products that drove leads',
        }), className: "products-that-drove-leads", error: !!error, isLoading: isLoading, noData: (chartData || []).length === 0, footer: (_jsx(TileFooter, { sourceLabel: sourceMessage(intl), sourceLink: getNvisionAnalyzeLeadsUrl(dateRange), "data-testid": testId, lastUpdated: new Date(lastUpdatedUTC || '') })), "data-testid": testId ? `${testId}-widget-tile` : 'ids-widget-tile', children: _jsx(HorizontalBarChart, { data: chartData || [], "data-testid": testId }) }));
};
export default ProductsThatDroveLeads;
